export default __webpack_public_path__ + "static/media/news-2.4983f34f.jpg";